// extracted by mini-css-extract-plugin
export default {"product-create__image":"styles_product-create__image__BnTlx"};